import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "table",
  "use": "table-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"table\"><path fill-rule=\"evenodd\" d=\"M19 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14ZM5 12h6V8H5v4Zm8 0h6V8h-6v4Zm-8 6h6v-4H5v4Zm8-4v4h6v-4h-6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol